import { intentGraphAppReducer, IntentGraphAppStates } from './intentGraph/reducers/app.redux';
import { IImmutableMap } from './state/redux';
import { createReduxRootDetached } from './state/store';

type YodaProps = {
  IntentGraph: IntentGraphAppStates;
};

export type YodaState = IImmutableMap<YodaProps>;

export const createNameSpacedStore = (nameSpace: string)=>{
  const [intentGraphRootReducer, rootStore] = createReduxRootDetached<YodaProps>(`${nameSpace}-Yoda`, {
    IntentGraph: intentGraphAppReducer
  });
  
  return {
    intentGraphRootReducer, rootStore
  }
}
